export const getAllSearchParams = (searchParams: URLSearchParams) => {
    const paramsMap = {};

    for (const key of searchParams.keys()) {
        paramsMap[key] = searchParams.getAll(key).length > 1 ? searchParams.getAll(key) : searchParams.get(key);
    }

    return paramsMap;
};
